export type BranchReviewPlace = {
  googleMapsReviewsUri: string;
  rating: number;
  userRatingCount: number;
};

type PlaceWithReviewLinks = google.maps.places.Place & {
  googleMapsLinks: { reviewsURI: string };
};

export const requestBranchReviews = async (
  id: string,
): Promise<BranchReviewPlace> => {
  const { Place } = (await google.maps.importLibrary(
    'places',
  )) as google.maps.PlacesLibrary;
  const placeDetails = new Place({ id }) as PlaceWithReviewLinks;

  await placeDetails.fetchFields({
    fields: ['userRatingCount', 'rating', 'googleMapsLinks'],
  });

  return {
    googleMapsReviewsUri: placeDetails.googleMapsLinks?.reviewsURI || '',
    rating: placeDetails.rating || 0,
    userRatingCount: placeDetails.userRatingCount || 0,
  };
};
